/* eslint-disable @reatom/unit-naming-rule */
import { reatomResource } from '@root/shared/lib'

import { fetchTxMakerRequestAction } from './maker-requests'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair/model'

export const reatomPairMaker = ({
  pairAddress,
  network,
  walletAddress,
}: {
  pairAddress: PairAddress
  network: Network.Network
  walletAddress: Address
}) => {
  return reatomResource(
    async (ctx) => {
      return ctx.schedule(() =>
        fetchTxMakerRequestAction(ctx, {
          network,
          walletAddress,
          pairAddress,
        }),
      )
    },
    {
      loadOnConnect: true,
    },
  )
}

export type PairMakerRequestModel = ReturnType<typeof reatomPairMaker>
